var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{attrs:{"disabled":_vm.processing || _vm.disabled,"variant":_vm.variant,"type":"submit"}},[(_vm.processing)?_c('font-awesome-icon',{attrs:{"icon":"sync-alt","spin":""}}):[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }